import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const userViewStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            marginTop: "120px",
            marginLeft: "50px",
        },
        smallIndicator: {
            marginTop: "30px",
            height: "20vh",
            width: "80vh",
            display: "flex",
            alignItems: "center",
        },
        title: {
            lineHeight: "41px",
            fontSize: "41px",
            fontWeight: 500,
            color: "#181818",
            marginBottom: "5px",
        },
    })
);
